export const mapPolygon = {
  hokkaido: '1400,50 1455,35 1460,55 1350,160 1370,180 1290,240 1190,280 1150,350 1040,300 1030,360 940,400 895,330 1000,70 1080,70 1220,170',
  tohoku: '940,400 1030,360 1050,380 1050,430 1090,500 1080,580 1060,620 1015,730 994,722 984,732 970,723 960,708 950,704 945,704 906,722 898,720 893,695 895,680 917,675 919,665 932,651 925,648 930,623 935,624 941,618 942,614 928,610 930,600 910,594',
  kanto: '1010,727 990,720 980,730 960,705 940,702 910,720 895,719 890,710 880,715 870,730 840,740 835,755 838,760 853,760 850,780 853,795 885,820 885,830 870,835 875,853 880,859 885,860 950,885 970,870 1020,815',
  chubu: '910,590 930,600 930,610 942,614 942,616 936,625 931,623 924,648 935,650 920,667 921,675 895,682 900,720 890,713 880,717 870,731 843,740 838,760 853,760 858,798 875,803 888,820 885,830 870,838 880,840 878,855 885,860 890,880 870,910 730,905 720,890 710,855 698,844 689,846 693,830 680,810 675,810 674,818 637,837 623,823 660,770 710,720 710,680 850,600',
  kinki: '730,905 720,890 710,855 690,845 695,830 680,810 677,809 660,824 637,835 630,830 625,820 612,790 545,800 553,832 548,833 532,855 535,883 575,950 600,980 640,990 680,950 720,930',
  chugoku: '545,800 553,830 534,855 538,883 500,898 430,905 350,950 335,925 265,900 270,870 470,780 490,750 470,730 440,770 470,780',
  shikoku: '350,950 430,905 500,898 538,883 575,950 515,996 430,1030 380,1030 360,1000',
  kyushu: '265,900 335,929 350,950 360,1000 240,1200 185,1205 155,1180 130,1070 170,1040 150,980 85,1005 80,970 170,890 195,840 170,820 145,880 170,890',
  okinawa: '180,270 200,300 240,320 300,340 380,280 400,250 410,140 390,130 360,200 300,240'
}

export const mapLabel = {
  hokkaido: { x: 1080, y: 240 },
  tohoku: { x: 980, y: 550 },
  kanto: { x: 910, y: 790 },
  chubu: { x: 750, y: 820 },
  kinki: { x: 620, y: 900 },
  chugoku: { x: 420, y: 860 },
  shikoku: { x: 450, y: 960 },
  kyushu: { x: 250, y: 1020 },
  okinawa: { x: 260, y: 280 }
}

export const areaToPrefTable = [
  {
    name: '北海道',
    key: 'hokkaido',
    pref_list: [
      { name: '道央', key: 'douou' },
      { name: '道南', key: 'dounan' },
      { name: '道北', key: 'douhoku' },
      { name: '道東', key: 'doutou' }
    ]
  },
  {
    name: '東北',
    key: 'tohoku',
    pref_list: [
      { name: '青森', key: 'aomori' },
      { name: '岩手', key: 'iwate' },
      { name: '秋田', key: 'akita' },
      { name: '宮城', key: 'miyagi' },
      { name: '山形', key: 'yamagata' },
      { name: '福島', key: 'fukushima' }
    ]
  },
  {
    name: '関東',
    key: 'kanto',
    pref_list: [
      { name: '東京', key: 'tokyo' },
      { name: '神奈川', key: 'kanagawa' },
      { name: '埼玉', key: 'saitama' },
      { name: '千葉', key: 'chiba' },
      { name: '茨城', key: 'ibaraki' },
      { name: '栃木', key: 'tochigi' },
      { name: '群馬', key: 'gunma' }
    ]
  },
  {
    name: '中部',
    key: 'chubu',
    pref_list: [
      { name: '静岡', key: 'shizuoka' },
      { name: '愛知', key: 'aichi' },
      { name: '岐阜', key: 'gifu' },
      { name: '山梨', key: 'yamanashi' },
      { name: '長野', key: 'nagano' },
      { name: '新潟', key: 'niigata' },
      { name: '富山', key: 'toyama' },
      { name: '石川', key: 'ishikawa' },
      { name: '福井', key: 'fukui' }
    ]
  },
  {
    name: '近畿',
    key: 'kinki',
    pref_list: [
      { name: '大阪', key: 'osaka' },
      { name: '兵庫', key: 'hyogo' },
      { name: '京都', key: 'kyoto' },
      { name: '滋賀', key: 'shiga' },
      { name: '奈良', key: 'nara' },
      { name: '和歌山', key: 'wakayama' },
      { name: '三重', key: 'mie' }
    ]
  },
  {
    name: '中国',
    key: 'chugoku',
    pref_list: [
      { name: '広島', key: 'hiroshima' },
      { name: '岡山', key: 'okayama' },
      { name: '山口', key: 'yamaguchi' },
      { name: '島根', key: 'shimane' },
      { name: '鳥取', key: 'tottori' }
    ]
  },
  {
    name: '四国',
    key: 'shikoku',
    pref_list: [
      { name: '香川', key: 'kagawa' },
      { name: '徳島', key: 'tokushima' },
      { name: '愛媛', key: 'ehime' },
      { name: '高知', key: 'kouchi' }
    ]
  },
  {
    name: '九州',
    key: 'kyushu',
    pref_list: [
      { name: '福岡', key: 'fukuoka' },
      { name: '佐賀', key: 'saga' },
      { name: '長崎', key: 'nagasaki' },
      { name: '大分', key: 'oita' },
      { name: '熊本', key: 'kumamoto' },
      { name: '宮崎', key: 'miyazaki' },
      { name: '鹿児島', key: 'kagoshima' }
    ]
  },
  {
    name: '沖縄',
    key: 'okinawa',
    pref_list: []
  }
]

export const isValidAreaAndPref = (area, mapName) => {
  const areaItem = areaToPrefTable.find((item) => item.key === area)
  if (!areaItem) {
    return false
  }
  const prefItem = areaItem.pref_list.find((item) => item.key === mapName)
  return !!prefItem
}
